import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Signup from "../Auth/signup";
import Login from "../Auth/login";
import { useSelector } from "react-redux";
import { MdArrowForward } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const isLoggedIn = useSelector((state) => state?.sessionState?.role);
  const navigate = useNavigate();
  useEffect(() => {
    if (isLoggedIn) {
      navigate(
        isLoggedIn === "CONSUMER"
          ? "/consumer_dashboard"
          : isLoggedIn === "ANALYST"
          ? "/analyst_dashboard"
          : isLoggedIn === "COMPANY_ADMIN"
          ? "admin_comp_dashboard"
          : isLoggedIn === "TRADER"
          ? "/trader_dashboard"
          : isLoggedIn === "GENERATOR"
          ? "/dashboard"
          : isLoggedIn === "BANKING"
          ? "/banking"
          : "/"
      );
    }
    localStorage.clear();
  }, []);

  const handleSignUpPopup = () => {
    setShowSignUpModal(true);
  };
  const handleSignUpClose = () => {
    setShowSignUpModal(false);
  };

  const handleLoginPopup = () => {
    setShowLoginModal(true);
  };
  const handleLoginClose = () => {
    setShowLoginModal(false);
  };

  return (
    <>
      <section className="full-screen-home-page">
        <Container>
          <Row>
            <Col md={12} className="z-inex-1">
              <h1 className="hero-section-title">
                Empowering India's Energy Future:
                <span>The Premier OTC Platform For The Power Market</span>
              </h1>
              <div className="d-flex justify-content-center gap-3 my-4">
                <button className="btn-signup-home" onClick={handleSignUpPopup}>
                  Sign up <MdArrowForward />
                </button>
                <button className="btn-login-home" onClick={handleLoginPopup}>
                  Log In <MdArrowForward />
                </button>
              </div>
            </Col>
            <Col md={6} className="mx-auto hero-image">
              <img
                className="img-fluid"
                src="images/hero-banner-image-1.png"
                alt="Hero Banner"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {showSignUpModal && (
        <Signup
          showSignUpModal={showSignUpModal}
          handleSignUpClose={handleSignUpClose}
          handleLoginPopup={handleLoginPopup}
        />
      )}

      {showLoginModal && (
        <Login
          showLoginModal={showLoginModal}
          handleLoginClose={handleLoginClose}
        />
      )}
    </>
  );
};

export default Home;
